import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import { componentStyles } from "./cluster-selection-signup-item-component.scss";
import PictureComponent from "/components/core/picture/picture-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import QuoteComponent from "components/core/boards-and-quotes-carousel/quote/quote-component";
import CloseIcon from "/static/svg/icons/close.svg";
class ClusterSelectionSignupItemComponent extends PureComponent {
    render() {
        const { title, imgSrc, color, onClick, activeQuote } = this.props;
        const componentStyle = {
            borderColor: color
        };
        return /*#__PURE__*/ _jsxs("div", {
            style: componentStyle,
            className: `jsx-${componentStyles.__hash}` + " " + "cluster-selection-signup-item-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    onClick: onClick,
                    className: `jsx-${componentStyles.__hash}` + " " + "close-icon-wrapper",
                    children: /*#__PURE__*/ _jsx(CloseIcon, {})
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "header",
                    children: [
                        /*#__PURE__*/ _jsx(PictureComponent, {
                            className: "image",
                            src: imgSrc,
                            alt: title
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: `jsx-${componentStyles.__hash}` + " " + "title",
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "signup-form-wrapper",
                    children: /*#__PURE__*/ _jsx(SignupFormComponent, {
                        buttonColor: "brand-iris",
                        ctaText: "Start now",
                        useCtaText: true,
                        forceHorizontal: true,
                        focusOnLoad: true
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "quote-component-wrapper",
                    children: /*#__PURE__*/ _jsx(QuoteComponent, {
                        activeQuote: activeQuote
                    })
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export { ClusterSelectionSignupItemComponent as default };
